import Keyvisual from '../lib/em/Keyvisual';

window.em = window.em || {};
window.em.keyvisual = new Keyvisual();